import React from 'react';
import { cn } from './lib/utils';

/* Native radio wrapped in a label — parity with legacy
   `~co/common/form` Radio (fixed --button-height row). */
export function Radio({ className, style, children, ...props }) {
  return (
    <label
      style={style}
      className={cn('ui-radio', className)}
    >
      <input
        type='radio'
        tabIndex='0'
        className='size-4 accent-accent'
        {...props}
      />
      {children}
    </label>
  );
}
